import { render, staticRenderFns } from "./company-info-detail.vue?vue&type=template&id=00b572f4&scoped=true&"
import script from "./company-info-detail.vue?vue&type=script&lang=js&"
export * from "./company-info-detail.vue?vue&type=script&lang=js&"
import style0 from "./company-info-detail.vue?vue&type=style&index=0&id=00b572f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b572f4",
  null
  
)

export default component.exports